/**
 * workflow
 */
'use strict';

import Gnav from './_modules/common/Gnav';
import commonShowEntry from './_modules/common/commonShowEntry';
import workflowScrollbar from './_modules/workflow/workflowScrollbar';
import scrollOverlay from './_modules/common/ScrollOverlay';
import AnchorScroll from './_modules/common/AnchorScroll';
import FloatBanner from './_modules/common/FloatBanner';

let main = [];

/**
 * DOMContentLoaded
 */
document.addEventListener('DOMContentLoaded', () => {
  new Gnav();
  new AnchorScroll();
  main['commonShowEntry'] = new commonShowEntry();
  main['FloatBanner'] = new FloatBanner();

  if (!Modernizr.objectfit) objectFitImages();
}, false);

/**
 * window.onload
 */
window.addEventListener('load', () => {
  main['commonShowEntry'].start();
  new workflowScrollbar();
  new scrollOverlay();

  main['FloatBanner'].start();
  main['FloatBanner'].scrollable();
}, false);

/**
 * window.unload（念のため）
 */
window.addEventListener('unload', () => {}, false);
